import { useStatsigClient } from "@statsig/react-bindings";

import { useFeatureFlag } from "@/features/featureFlag";

/**
 * Custom hook to check if the WhatsApp conversational components
 * (Automations tab / ice breakers) feature is enabled.
 *
 * Returns `true` if either the local feature flag
 * ("enable-whatsapp-conversational-components") or the Statsig feature gate
 * ("enable_whatsapp_conversational_components") is enabled. This mirrors
 * `useWhatsappCompliance` (the existing gate hook on this same page) for
 * consistency, rather than the newer `useGateValue` pattern the
 * polifonia-feature-flag skill otherwise recommends for new gate-only hooks
 * -- there is no local-override half to a gate-only hook, so matching the
 * sibling tab's mechanism took precedence here.
 */
export const useWhatsappConversationalComponents = (): boolean => {
  const featureFlag = useFeatureFlag(
    "enable-whatsapp-conversational-components",
  );

  const statsigClient = useStatsigClient();
  const featureGate = statsigClient.checkGate(
    "enable_whatsapp_conversational_components",
  );

  return featureFlag || featureGate;
};
